import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
@Component({
  selector: 'app-paremployee-del-dialog',
  templateUrl: './paremployee-del-dialog.component.html',
  styleUrls: ['./paremployee-del-dialog.component.css']
})
export class ParemployeeDelDialogComponent implements OnInit {
  DocTypeErrMsg: any;
  DocTypeErr:boolean = false;
employeeId: any;
_id:any;
  constructor(private parEmployeeService: ParEmployeeService, public dialog: MatDialog, public dialogRef: MatDialogRef<ParemployeeDelDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit() {
  }
  deleteDocument() {
    this.employeeId =this.data._id;
    this.parEmployeeService.deleteParEmployee(this.employeeId).subscribe(res => {
      this.parEmployeeService.load.next('success');
      this.onNoClick();
    }, error => {
      this.DocTypeErrMsg = "Delete PAREmployee" + error;
      this.DocTypeErr = true;
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-del-dialog/paremployee-del-dialog.component.ts